import { getNames, getUnique } from '../../helpers/helpers';
import { formatProjectLabelFromCompanySettings } from '../../projects/projectHelpers';

export default function getEmployeeProjectFilters({
  showEmployee = true,
  showWorkType,
  showBreak,
  showProject = true,
  showPhase = true,
  showCostcode = true,
  showNoneCostcodeOption = true,
  showGlobalCostcodes = true,
  showServiceLocations,
  onFilterToggle,
  onCheckChanged,
  checkedColumns = new Set(),
  users = [],
  projects = [],
  phases = [],
  costcodeFetchOptions, // async (params) => [{ value, label }]
  costcodeInitialOptions = [],
  costcodeProjects = [],
  costcodePhases = [],
  projectCheckDisabled = false,
  settings = {},
  t,
  showActiveUsersOnly = true,
  onActiveUsersToggle = () => {},
  filters: {
    users: userFilters = users, // Array of users
    projects: projectFilters, // Sets of names
    phases: phaseFilters, // Sets of names
    costcodes: costcodeFilters, // Set of cost code ids (empty = all)
  } = {},
}) {
  const filters = [];
  if (showEmployee) {
    const filteredUsers = showActiveUsersOnly ? users.filter((user) => user.active) : users;
    const userNames = getNames(filteredUsers);
    filters.push({
      content: userNames,
      title: 'Employee',
      onFilterToggle: (checked) => onFilterToggle('users', checked),
      checkDisabled: true,
      selected: new Set(
        userFilters === users
          ? userNames
          : getNames(userFilters),
      ),
      showActiveUsersOnly,
      onActiveUsersToggle,
    });
  }

  if (showWorkType) {
    const content = ['Project', 'Service'];
    if (showBreak) content.push('Break');
    filters.push({
      content,
      title: 'Work Type',
      key: 'type',
      onFilterToggle: (checked) => onFilterToggle('workType', checked),
      checkDisabled: true,
    });
  }

  if (showProject) {
    const projectNames = getUnique(projects, {
      valueExtractor: ({ name, number } = {}) => (
        formatProjectLabelFromCompanySettings({ name, number, settings })
      ),
    }).concat('None');
    filters.push({
      content: projectNames,
      title: t('Project'),
      key: 'project',
      onFilterToggle: (checked) => onFilterToggle('projects', checked),
      onCheckChanged: (checked) => onCheckChanged('project', checked),
      checkDisabled: projectCheckDisabled,
      checked: projectCheckDisabled || checkedColumns.has('project'),
      selected: projectFilters ?? new Set(projectNames),
    });
  }

  if (showPhase) {
    const phaseNames = getUnique(phases).concat('None');
    filters.push({
      content: phaseNames,
      title: 'Phase',
      key: 'phase',
      onFilterToggle: (checked) => onFilterToggle('phases', checked),
      onCheckChanged: (checked) => onCheckChanged('phase', checked),
      checked: checkedColumns.has('phase'),
      selected: phaseFilters ?? new Set(phaseNames),
    });
  }

  if (showCostcode) {
    filters.push({
      filterType: 'costcode',
      title: 'Cost Code',
      key: 'costcode',
      fetchOptions: costcodeFetchOptions,
      initialOptions: costcodeInitialOptions,
      projects: costcodeProjects,
      phases: costcodePhases,
      selectedProjects: projectFilters,
      showNoneCostcodeOption,
      showGlobalCostcodes,
      onFilterToggle: (checked) => onFilterToggle('costcodes', new Set(checked)),
      onCheckChanged: (checked) => onCheckChanged('costcode', checked),
      checked: checkedColumns.has('costcode'),
      selected: costcodeFilters ?? new Set(),
    });
  }
  if (showServiceLocations) {
    filters.push({
      title: 'Service Location',
      key: 'serviceLocation',
      onCheckChanged: (checked) => onCheckChanged('serviceLocation', checked),
      checked: checkedColumns.has('serviceLocation'),
    });
  }
  return filters;
}

export const EmployeeFilter = (users, onFilterToggle) => ({
  content: getNames(users),
  title: 'Employee',
  onFilterToggle,
  checkDisabled: true,
});
